<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'fuikIndex'
    
  }
</script>

<style lang="scss" scoped>

</style>